/* eslint-disable no-nested-ternary */
import format from "date-fns/format";
import { keyBy } from "lodash/fp";
import {
  ALL_DATES,
  INTEGER_KEYS,
  AppliedFilterFriendLabelMap,
  DATES,
  DROPDOWN_KEYS,
  DROPDOWN_REDUX_KEY_MAPPER,
  EXCLUDE_DATES,
  OS_DROPDOWN_KEYS,
} from "../../../../contants";
import { ROUTES } from "../../../../utils/constants";
import { isEmptyObj, isOSKey } from "../../../../utils/helper";

const DATE_FORMAT = "yyyy-MM-dd";
const PLUS = "plus";
// const OS_LABEL = "organisationStructure";
export const POSITIONS_KEY = "positions";
export const MAINLINE_POSITION_KEY = "mainlinePositions";

export const performOperation = (value, limit, operator = PLUS) =>
  operator === PLUS ? Number(value) + limit : Number(value) - limit;

export const getRoutePath = () => ROUTES.REPORTS_FRIEND.path;
export const getRouteForFriendSummary = () =>
  ROUTES.REPORTS_FRIEND_SUMMARY.path;
export const getRoutePathforDeactivate = () =>
  ROUTES.REPORTS_DEACTIVATED_FRIEND.path;
export const getRoutePathforChangedToMember = () =>
  ROUTES.REPORTS_CHANGED_TO_MEMBER.path;
export const getRoutePathforChangedToMemberTrends = () =>
  ROUTES.REPORTS_FRIEND_CHANGED_TO_MEMBER_TRENDS.path;
export const getRoutePathforNewFriendTrends = () =>
  ROUTES.REPORTS_NEW_FRIEND_TRENDS.path;
export const getRoutePathforFriendToMemberGrowth = () =>
  ROUTES.REPORTS_FRIEND_TO_MEMBER_GROWTH.path;

const handlePositions = (queryObject, currObj, key) => {
  const currentPositions = currObj[POSITIONS_KEY] ?? [];

  const keyValue = queryObject[key]
    ? queryObject[key].split(",").map(Number)
    : [];

  return [...currentPositions, ...keyValue];
};

const handleOS = (queryObject, currObj, key) => {
  // const currentOS = currObj[OS_LABEL] ?? {};

  return Object.assign(currObj, {
    // [OS_LABEL]: currentOS,
    [key]: Number(queryObject[key]),
  });
};

export const getFormattedQuery = (queryObject) =>
  !isEmptyObj(queryObject)
    ? Object.keys(queryObject).reduce((acc, currKey) => {
        let value = queryObject[currKey];
        const key = currKey === MAINLINE_POSITION_KEY ? POSITIONS_KEY : currKey;

        if (INTEGER_KEYS.includes(currKey)) {
          value = Number(queryObject[currKey]);
        } else if (ALL_DATES.includes(currKey)) {
          value = format(new Date(queryObject[currKey]), DATE_FORMAT);
        } else if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(currKey)) {
          value = handlePositions(queryObject, acc, currKey);
        } else if (OS_DROPDOWN_KEYS.includes(currKey)) {
          return handleOS(queryObject, acc, currKey);
        }
        return Object.assign(acc, {
          [key]: value,
        });
      }, {})
    : {};

// ✅ FIXED FUNCTION with null checks
export const getFilters = (queryObject, metaData, disabledOSKeys = []) => {
  // ✅ Early return if no data
  if (!queryObject || !metaData) {
    return [];
  }

  // ✅ Ensure disabledOSKeys is array
  const safeDisabledOSKeys = Array.isArray(disabledOSKeys)
    ? disabledOSKeys
    : [];

  return Object.keys(queryObject).reduce((acc, curr) => {
    if (!EXCLUDE_DATES.includes(curr)) {
      // handle dates
      if (DATES.includes(curr)) {
        const key = curr.split("From")[0];
        acc.push({
          key: curr,
          displayName: AppliedFilterFriendLabelMap[key],
          value: `${queryObject[curr]} - ${queryObject[`${key}To`]}`,
          disabled: safeDisabledOSKeys.includes(curr), // ✅ FIXED
        });
        return acc;
      }
      if (curr === "startDate") {
        const value = queryObject[curr];
        acc.push({
          key: curr,
          displayName: "Date From",
          value,
          disabled: safeDisabledOSKeys.includes(curr), // ✅ FIXED
        });
        return acc;
      }

      if (curr === "endDate") {
        const value = queryObject[curr];
        acc.push({
          key: curr,
          displayName: "Date To",
          value,
          disabled: safeDisabledOSKeys.includes(curr), // ✅ FIXED
        });
        return acc;
      }

      // handle dropdowns
      if (DROPDOWN_KEYS.includes(curr) || OS_DROPDOWN_KEYS.includes(curr)) {
        const pool = isOSKey(curr)
          ? metaData?.organisationStructure?.[
              DROPDOWN_REDUX_KEY_MAPPER[curr]
            ] || []
          : metaData?.[DROPDOWN_REDUX_KEY_MAPPER[curr]] || [];

        // ✅ Check if pool exists and is array
        const selectedValue = Array.isArray(pool)
          ? pool.find(
              (p) =>
                (p?.structureId || p?.divisionId || p?.cityId || p?.stateId) ===
                Number(queryObject[curr])
            )
          : null;

        acc.push({
          key: curr,
          displayName: AppliedFilterFriendLabelMap[curr],
          value:
            selectedValue?.shortName ||
            selectedValue?.name ||
            selectedValue?.cityName ||
            selectedValue?.stateName ||
            queryObject[curr],
          disabled: safeDisabledOSKeys.includes(curr), // ✅ FIXED
        });
        return acc;
      }

      if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(curr)) {
        // ✅ Add safety checks
        const positions = metaData?.positions || [];
        const positionsMap = keyBy("value", positions);
        const inputPositions = queryObject[curr]
          ? queryObject[curr].split(",")
          : [];

        const positionsLabel = inputPositions
          ?.map((postion) => positionsMap[postion]?.entityTitle || postion)
          .filter(Boolean); // ✅ Remove undefined values

        acc.push({
          key: curr,
          displayName: AppliedFilterFriendLabelMap[curr],
          value: positionsLabel.join(", ") || queryObject[curr],
          disabled: safeDisabledOSKeys.includes(curr), // ✅ FIXED (Add disabled property)
        });
        return acc;
      }

      // rest
      acc.push({
        key: curr,
        displayName: AppliedFilterFriendLabelMap[curr],
        value: queryObject[curr],
        disabled: safeDisabledOSKeys.includes(curr), // ✅ FIXED
      });
      return acc;
    }
    return acc;
  }, []);
};

export const handleDependencyFilter = (query) => {
  const updatedQueryWithOS = { ...query };
  if (!updatedQueryWithOS?.areaId) {
    delete updatedQueryWithOS.zoneId;
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    // OLD:
    // delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.zoneId) {
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    // OLD:
    // delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.regionId) {
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    // OLD:
    // delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.chapterId) {
    delete updatedQueryWithOS.districtId;
    // OLD:
    // delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.districtId) {
    delete updatedQueryWithOS.districtId;
    // OLD:
    // delete updatedQueryWithOS.blockId;
  }

  // state and divisions
  if (!updatedQueryWithOS?.state) {
    delete updatedQueryWithOS.city;
  }
  if (!updatedQueryWithOS?.divisionId) {
    delete updatedQueryWithOS.subdivisionId;
  }

  return updatedQueryWithOS;
};
